import { DOCUMENT } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastModule } from "@openng/optimus-ui/toast";
import { registerLocaleData } from "@angular/common";
import de from "@angular/common/locales/de";
import { Optimus } from "@openng/optimus-ui/config";
import { isSupportedLang } from "../../models/ui/supportedLangs";

@Component({
  standalone: true,
  selector: "app-root",
  imports: [RouterOutlet, ToastModule],
  templateUrl: "./root.component.html",
  styleUrl: "./root.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class RootComponent {
  private translateService = inject(TranslateService);
  private config = inject(Optimus);
  private document = inject(DOCUMENT);

  constructor() {
    registerLocaleData(de);
    const localStorage = this.document.defaultView?.localStorage;
    this.translateService.addLangs(["en", "de"]);
    this.translateService.setDefaultLang("de");

    const browserLang = this.translateService.getBrowserLang();
    const savedLang = localStorage?.getItem("lang");
    const lang = isSupportedLang(savedLang) ? savedLang : isSupportedLang(browserLang) ? browserLang : "de";
    localStorage?.setItem("lang", lang);

    // set lang attribute of html to corresponding language whenever language changes:
    this.translateService.onLangChange.subscribe((event) => {
      this.document.documentElement.lang = event.lang;
      this.translateService.get("primeng").subscribe((translations) => this.config.setTranslation(translations));
    });
    this.translateService.use(lang);
  }
}
